export default {
  // Constructor de encuestas: secciones, imagen y lógica de saltos
  untitled_question: 'Untitled question',
  untitled_section: 'Untitled section',
  section_description_placeholder: 'Title description',
  attach_image_to_question: 'Attach an image to the question:',
  attach_photo: 'Attach photo',
  no_image_attached: 'No image attached',
  image_attached: 'Image attached',
  add_image: 'Add image',
  remove_image: 'Remove image',
  add_section: 'Add section',
  add_section_below: 'Add section below',
  add_question_to_section: 'Add question to this section',
  clone_section: 'Clone section',
  delete_section: 'Delete section',
  select_question: 'Select a question',
  show_if_answer_is: 'Show if the answer is',
  add_rule: 'Add rule',
  jump_next: 'Next question',
  jump_question: 'Select another question in this same section',
  jump_section: 'Change section',
  jump_submit: 'Submit survey',
  jump_question_option: 'Question {number} ({name})',
  jump_section_option: 'Section {number} ({name})',
  jump_help_review: 'For each answer option of this item you define {what}.',
  jump_help_review_what: 'what should happen next',
  jump_help_action: 'Choose where to go: {next}, {question}, {section} or {submit}.',
  jump_help_target: 'If you choose {question} or {section}, specify the question or section to jump to.',
  location_mode_manual: 'Allow choosing a location',
  location_mode_auto: 'Automatic geolocation',

  // Catálogo de tipos de ítem — constructor de encuestas (NewItem.vue, components/surveys/)
  build: {
    'form-checkbox': 'Checkboxes',
    'form-yes-no': 'Yes/No/NA',
    'form-option': 'Multiple Choice',
    'form-select': 'Dropdown',
    'form-matrix': 'Matrix',
    'form-input-text': 'Short Answer',
    'form-textarea': 'Long Answer',
    'form-input-email': 'Email',
    'form-input-number': 'Number',
    'form-date': 'Date',
    'form-hour': 'Hour',
    'form-satisfaction': 'Satisfaction',
    'form-rating': 'Rating',
    'form-nps': 'NPS',
    'form-love-scale': 'Appreciation',
    'form-image-response': 'Image Response'
  }
}
